<section class="dashboard">

    <header class="row page-header">
        <div class="col-md-12">
            <h2 class="title">{{ (propertyName$ |async) }}</h2>
        </div>
    </header>

    <ng-container *ngIf="(selectedFiscalYear$ | async)?.isPreviousFiscalYear">
        <sp-dashboard-past></sp-dashboard-past>
    </ng-container>

    <ng-container *ngIf="(selectedFiscalYear$ | async)?.isCurrentFiscalYear">
        <sp-dashboard-current></sp-dashboard-current>
    </ng-container>

    <ng-container *ngIf="(selectedFiscalYear$ | async)?.isFutureFiscalYear">
        <sp-dashboard-future></sp-dashboard-future>
    </ng-container>
</section>
